export interface TagFilterType {
  selectedTags: server.dto.TagSmall[]
  initialTags: server.dto.TagSmall[]
  filterType: server.dto.WhereInOrNotIn
}

export const getSortedTags = (filter: TagFilterType) => {
  return [...filter.selectedTags].sort((a, b) => a.title.localeCompare(b.title));
};

export const initialTagFilter: TagFilterType = {
  selectedTags: [],
  initialTags: [],
  filterType: "in"
};
